module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/characters/apprenticesBackToBack-3828e498bf581cc27ecb2f351a349b23.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/characters/apprenticesBackToBack.png
// module id = 2262
// module chunks = 2